import React, {Dispatch, InputHTMLAttributes, useId} from "react"
import {ErrorMessage, useFormikContext} from "formik"
import {flattenObject} from "../../utilities/helpers"
import Checkbox from "../Checkbox/Checkbox"

interface Props extends InputHTMLAttributes<HTMLInputElement> {
	name: string
	label?: string
	checked: boolean
	onChange: Dispatch<any>
	light?: boolean
}

export default function CheckboxField({name, label, checked, onChange, light, ...inputProps}: Props) {
	const checkboxId = `${name}-${useId()}`
	const {touched, errors} = useFormikContext()
	const hasError = flattenObject(touched).hasOwnProperty(name) && flattenObject(errors).hasOwnProperty(name)

	return (
		<div className="checkbox-field">
			<div className="checkbox-and-label-container">
				<Checkbox
					name={name}
					checked={checked}
					onChange={onChange}
					isValid={!hasError}
					id={checkboxId}
					light={light}
					{...inputProps}
				/>
				{label && (
					<label className="text" htmlFor={checkboxId}>
						{label}
					</label>
				)}
			</div>
			<ErrorMessage name={name} component="div" className="error" />
		</div>
	)
}
